﻿module.exports = (function ($) {
	return {
		init: function () {
			if ($('.copyForMobile').length > 0) {
				this.initMobile();
			}
		},
		initMobile: function () {
			// Copy any element flagged with the class copyForMobile, into the bottom hidden element right-col-content
			$('.copyForMobile').each(function () {
				$(this).clone().appendTo("#right-col-content");
			});
		}
	}
});